__webpack_require__.p = "/news-monkey3/";